/**
 * This list shows the possible error codes from backend
 */

export const CANNOT_BOOK = 'CannotBook';

export const PENDING_PAYMENT = 'PendingPayment';
